import type { Person } from '@/api/pending'

/** Final pt-BR copy (handoff §5), including the fixes for the strings the reference left in English. */
export const S = {
  searchTitle: 'Buscar pessoa',
  searchPlaceholder: 'marina.costa@example.com ou +55 11 9…',
  emptyTitle: 'Buscar na base de usuários',
  emptyDescription: 'Digite pelo menos dois caracteres de um e-mail, telefone ou nome.',
  noHit: (q: string) =>
    `Ninguém corresponde a “${q}”. A pessoa talvez ainda não tenha se cadastrado.`,
  invite: 'Enviar convite por e-mail',
  inviteSoon: 'Convites por e-mail chegam em breve',
  similar: 'Nome parecido',
  noUnitHere: 'sem unidade aqui',
  review: 'Revisar',
  unitsTitle: 'Unidades',
  towerLabel: 'Torre',
  emptyUnit: 'Vazia — sem morador vinculado',
  detach: 'Remover da unidade',
  detached: (name: string, unit: string) => `${name} removido do ${unit}`,

  step1Title: 'É a pessoa certa?',
  account: (id: number, created: string) => `Conta Condi #${id} · criada em ${created}`,
  active: 'Ativo',
  inactive: 'Inativo',
  verified: 'Verificado',
  unverified: 'Não verificado',
  cancel: 'Cancelar',
  continue: 'Sim, continuar',
  cautionUnverified:
    'Esta conta tem contatos não verificados. Confirme com o morador pessoalmente ou por telefone — qualquer pessoa pode se cadastrar com um e-mail não verificado.',
  cautionSimilar: (others: Person[]) =>
    `${others.length === 1 ? 'Outra conta tem nome parecido' : `${others.length} outras contas têm nome parecido`}: ${others
      .map((o) => `${o.first_name} ${o.last_name} (CPF ${o.tax_id_masked})`)
      .join('; ')}. Confira o CPF com os documentos do morador antes de continuar.`,
  gateTitle: 'Digite os 4 últimos dígitos do CPF',
  gateHelp:
    'Ocultamos acima de propósito — pergunte à pessoa ou confira o documento, para a confirmação não vir da tela.',
  gateMatch: 'Confere com esta conta',
  gateMismatch: 'Não confere — verifique se é a pessoa certa',
  gateChecking: 'Conferindo…',
  gateError: 'Não foi possível conferir agora. Tente de novo.',

  step2Title: (first: string) => `Vincular ${first} a uma unidade`,
  notThem: 'Não é essa pessoa?',
  unit: 'Unidade',
  empty: 'vazia',
  scope: 'Escopo concedido',
  back: 'Voltar',
  attach: 'Vincular morador',
  attached: (name: string, unit: string, tower: string) => `${name} vinculado a ${unit} · ${tower}`,
  attachError: 'Não foi possível vincular agora. Tente de novo.',
} as const

export const SEEN_NEVER = 'Nunca abriu o app'

/** "Hoje", "Ontem", "há N dias", or "Nunca abriu o app". */
export function lastSeenLabel(iso: string | null, now: number = Date.now()): string {
  if (!iso) return SEEN_NEVER
  const days = Math.floor((now - Date.parse(iso)) / 86_400_000)
  if (days <= 0) return 'Hoje'
  return days === 1 ? 'Ontem' : `há ${days} dias`
}
